import NavbarCTAButton from "./NavbarCTAButton";

interface HeroSecondaryButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  icon?: React.ReactNode;
}

/**
 * Secondary CTA button used inside the hero carousel. White-outline pill on dark bg,
 * hidden on mobile (sm+). Delegates to NavbarCTAButton with scrolled=false for
 * consistent hover style (white fill + green text).
 */
export default function HeroSecondaryButton({
  children,
  onClick,
  icon,
}: HeroSecondaryButtonProps) {
  return (
    <NavbarCTAButton
      scrolled={false}
      onClick={onClick}
      icon={icon}
      h={{ base: "2.85rem", tablet: "3.15rem" }}
      px={{ base: "1.2rem", tablet: "1.5rem" }}
      w={{ base: "full", tablet: "auto" }}
      minW={{ tablet: "9.5rem" }}
      fontSize={{ base: "0.9rem", tablet: "0.95rem" }}
    >
      {children}
    </NavbarCTAButton>
  );
}
